module.exports = __webpack_public_path__ + "static/contact-d55156cf5f733a4324dffe81bd2d3087.svg";